import React from 'react';
import Header from './Header';
import { useFeatureFlags } from '../hooks/useFeatureFlags';

interface PageLayoutProps {
  children: React.ReactNode;
  currentPage?: string;
}

const PageLayout: React.FC<PageLayoutProps> = ({ children, currentPage }) => {
  const { validationMode } = useFeatureFlags();

  return (
    <div style={{ minHeight: '100vh', background: 'var(--color-bg)' }}>
      <Header {...(currentPage !== undefined && { currentPage })} />
      {validationMode && (
        <div
          style={{
            position: 'sticky',
            top: 80,
            zIndex: 9,
            background: '#6B7B5A',
            color: '#fff',
            textAlign: 'center',
            padding: '10px 24px',
            fontWeight: 700,
            fontSize: 17,
            letterSpacing: 0.5,
          }}
        >
          ⚠️ 驗測模式已開啟 — 此模式僅適用於測試，請勿用於正式作業
        </div>
      )}
      {children}
    </div>
  );
};

export default PageLayout;
